var map = {
	"./bluntschli.svg": "0916",
	"./ehrlich.svg": "1c1c",
	"./eugenHuber.svg": "f47f",
	"./gierke.svg": "a99b",
	"./heusler.svg": "e74e",
	"./jhering.svg": "a0b8",
	"./keller.svg": "064d",
	"./kempin.svg": "a37b",
	"./locre.svg": "f7d1",
	"./mommsen.svg": "2494",
	"./planck.svg": "0195",
	"./rossel.svg": "3344",
	"./savigny.svg": "0d3e",
	"./unger.svg": "cabb",
	"./vonGlueck.svg": "37ef",
	"./vontuhr.svg": "a68c",
	"./warnkoenig.svg": "4320",
	"./windscheid.svg": "fe64"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5f35f";